import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import * as React from "react";

const SHIPPEEK_LOGO_URL = "/shippeek-mark.svg";

type AuthCardProps = {
  title: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

export function AuthCard({ title, description, children, footer }: AuthCardProps) {
  return (
    <div className="min-h-screen grid place-items-center p-4 bg-background">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src={SHIPPEEK_LOGO_URL} alt="ShipPeek" className="mb-3 size-10 rounded-lg" />
          <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground font-mono">ShipPeek TMS</p>
        </div>

        <Card>
          <CardHeader className="text-center pb-2">
            <CardTitle className="text-lg font-semibold normal-case tracking-normal font-sans">{title}</CardTitle>
            {description ? <CardDescription className="text-sm">{description}</CardDescription> : null}
          </CardHeader>
          <CardContent className="pt-2">{children}</CardContent>
          {footer ? (
            <CardFooter className="justify-center text-sm text-muted-foreground">{footer}</CardFooter>
          ) : null}
        </Card>
      </div>
    </div>
  );
}
